import template from './sessionTimeoutModal.html';
import { SessionTimeoutModalController } from './sessionTimeoutModal.controller';
import './sessionTimeoutModal.scss';

export const SessionTimeoutModalServiceModule = angular
    .module('app.components.sessionTimeoutModal.sessionTimeoutModalService', [
        'ngMaterial',
        SessionTimeoutModalController
    ]).service('sessionTimeoutModalService', ($mdDialog) => {
        function openModal() {
            return $mdDialog.show({
                template,
                controller: 'SessionTimeoutModalController',
                parent: angular.element('body'),
                clickOutsideToClose: false
            });
        }
        return {
            openModal
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/sessionTimeoutModal/sessionTimeoutModal.service.js